import React, { PureComponent } from 'react';
import ButtonConfirmar from './ButtonConfirmar.jsx'
import ButtonDenegar from './ButtonDenegar.jsx'
import ButtonEditar from './ButtonEditar.jsx'
import ButtonEliminar from './ButtonEliminar.jsx'
import ButtonExpandir from './ButtonExpandir.jsx'
import DateMask from "../../../../Common/Components/Mask/DateMask.jsx"

class TablaRow extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { cobranza, confirmarCobranza, editar, denegarCobranza, eliminarCobranza, expandirRow, claseFlecha, permisosUsuario } = this.props;

        let claseEstado = "";
        const permisos = (permisosUsuario || {});

        //VER QUE ESTADOS MANEJA PARA ESTO
        switch (cobranza.Estado) {
            case "Anulado":
                claseEstado = "modal-news-modifications-button-lightgray-central-rectangle";
                break;
            case "Completado":
                claseEstado = "modal-news-modifications-button-lightblue-central-rectangle";
                break;
            case "Confirmado":
                claseEstado = "modal-news-modifications-button-lightgreen-central-rectangle";
                break;
            case "Denegado":
                claseEstado = "modal-news-modifications-button-lightred-central-rectangle";
                break;
            case "Cta. Tc. Env.":
                claseEstado = "modal-news-modifications-button-gray-central-rectangle";
                break;
            case "Cta. Tc. Acept":
                claseEstado = "modal-news-modifications-button-green-central-rectangle";
                break;
            case "Cta. Tc. Rech.":
                claseEstado = "modal-news-modifications-button-board-central-rectangle";
                break;
            case "Emp. Enviado":
                claseEstado = "modal-news-modifications-button-stronggreen-central-rectangle";
                break;
            case "Emp. Acept":
                claseEstado = "modal-news-modifications-button-green-central-rectangle";
                break;
            case "Tc. Pr. Acept":
                claseEstado = "modal-news-modifications-button-gray-central-rectangle";
                break;
            case "Emp. Rechaza":
                claseEstado = "modal-news-modifications-button-board-central-rectangle";
                break;
            case "Borrador":
                claseEstado = "modal-news-modifications-button-board-central-rectangle";
                break;
            default:
                claseEstado = "modal-news-modifications-button-lightgray-central-rectangle";
                break;
        }

        return (
            <tr>
                <td className="default-td">
                    <DateMask fecha={cobranza.FechaValor} />
                </td>
                <td className="default-td">
                    <DateMask fecha={cobranza.FechaImputacion} />
                </td>
                <td className="default-td">
                    {cobranza.ImportePesos}
                </td>
                <td className="default-td">
                    {cobranza.ImporteDolares}
                </td>
                <td className="default-td">
                    {/*cobranza.referencia*/}
                </td>
                <td className="default-td">
                    <div className={claseEstado}>
                        <label className="modal-news-modifications-label-tipografy-central-rectangle">{cobranza.Estado}</label>
                    </div>
                </td>
                <td className="default-td" colSpan="7">
                    {permisos.Confirmacion &&
                        <ButtonConfirmar cobranza={cobranza}
                            confirmarCobranza={confirmarCobranza}
                        />
                    }
                    {permisos.Confirmacion &&
                        <ButtonDenegar cobranza={cobranza}
                            denegarCobranza={denegarCobranza}
                        />
                    }
                    {permisos.Modificacion &&
                        <ButtonEditar cobranza={cobranza}
                            editar={editar} />
                    }
                    {permisos.Baja &&
                        <ButtonEliminar cobranza={cobranza}
                            eliminarCobranza={eliminarCobranza}                            
                        />
                    }
                </td>
                <td className="default-td">
                    <ButtonExpandir id={cobranza.Id}
                        expandirRow={expandirRow}
                        claseFlecha={claseFlecha}
                    />
                </td>
            </tr>
        );
    }
}

export default TablaRow;